import { Component, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-card">
            <div className="error-boundary-icon">!</div>
            <h2 className="error-boundary-title">Something went wrong</h2>
            <p className="error-boundary-message">{this.state.error.message}</p>
            <button
              className="btn-primary"
              onClick={() => { window.location.reload(); }}
            >
              Reload page
            </button>
            <details className="error-boundary-details">
              <summary>Technical details</summary>
              <pre>{this.state.error.stack}</pre>
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
